import i18n from "PFCore/i18n";

export const LOADING_ITEM = { id: "LOADING_ITEM", text: i18n.t("core:loading") }; // Symbol to match in other places
